import { Axios } from 'utils/AxiosConfig'

export const getTnC = async (code) => {
  const { data: response } = await Axios.get(`/public/term-and-condition/${code}`)
  return response
}
